import React, { useState, useEffect } from "react";
import MidnightTimer from "./MidnightTimer";

export default function Result(props) {
  const [showToast, setShowToast] = useState(false);
  const [showStreamingDropdown, setShowStreamingDropdown] = useState(false);

  const todaysSong = props.todaysSong;
  const seconds = props.songSeconds / 1000;
  const second_word = seconds === 1 ? "second" : "seconds";

  let result_description = "Unlucky!";
  let result_comment = `Better luck tomorrow! \n\n`;
  const result_box_class = ["", "", "", "", "", ""];

  for (let i = 0; i < props.isWrong.length; i++) {
    if (props.isWrong[i]) {
      result_box_class[i] = "wrong";
    }
  }

  for (let k = 0; k < props.isSkipped.length; k++) {
    if (props.isSkipped[k]) {
      result_box_class[k] = "skipped";
    }
  }

  if (props.isSuccessfulGuess) {
    result_description = "You got it - big up!";
    result_comment = `You got today's Jungle Jumble within ${seconds} ${second_word} \n\n`;
    result_box_class[props.numSkips] = "correct";
  }

  const sendStats = async () => {
    try {
      const statsData = {
        isSuccessfulGuess: props.isSuccessfulGuess,
        songSeconds: props.songSeconds,
        numSkips: props.numSkips,
        songTitle: todaysSong.title_short,
        artistName: todaysSong.artist.name,
        album: todaysSong.album.title || '',
        duration: todaysSong.duration || 0,
        link: todaysSong.link || '',
        isWrong: props.isWrong,
        isSkipped: props.isSkipped
      };

      await fetch('/stats', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(statsData)
      });
    } catch (error) {
      console.log('Stats tracking failed:', error);
    }
  };

  useEffect(() => {
    sendStats();
  }, []);

  function generateShareText() {
    const today = new Date().toLocaleDateString("en-GB", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    });

    const emojiMap = {
      wrong: "❌",
      skipped: "⏭️",
      correct: "✅",
      "": "⬜",
    };

    const emojiGrid = result_box_class
      .map((boxClass) => emojiMap[boxClass] || "⬜")
      .join("");

    let resultText;
    
    if (props.isSuccessfulGuess) {
      const successMessages = [
        `Got it in ${seconds} ${second_word}! 🎵`,
        `Nailed it - ${seconds} ${second_word}! 🎵`,
        `I crushed it - ${seconds} ${second_word}! 🎵`,
        `Winner winner - ${seconds} ${second_word}! 🎵`,
        `Locked in - ${seconds} ${second_word}! 🎵`,
      ];
      resultText = successMessages[Math.floor(Math.random() * successMessages.length)];
    } else {
      const failureMessages = [
        "Better luck next time! 🎵",
        "Not this one! 🎵",
        "Booo, I didn't get it! 🎵",
        "Close one! 🎵",
        "Unlucky! 🎵",
      ];
      resultText = failureMessages[Math.floor(Math.random() * failureMessages.length)];
    }

    const shareText = `Jungle Jumble ${today}\n\n${emojiGrid}\n\n${resultText}\n\nhttps://junglejumblegame.com`;
    return shareText;
  }

  async function handleShare() {
    const shareText = generateShareText();

    try {
      await navigator.clipboard.writeText(shareText);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 2000);
    } catch {
      const textArea = document.createElement("textarea");
      textArea.value = shareText;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        if (document.execCommand("copy")) {
          setShowToast(true);
          setTimeout(() => setShowToast(false), 2000);
        } else {
          alert("Copy to clipboard failed. Please copy manually.");
        }
      } catch {
        alert("Copy to clipboard failed. Please copy manually.");
      }

      document.body.removeChild(textArea);
    }
  }

  function handleListenNow() {
    setShowStreamingDropdown(!showStreamingDropdown);
  }

  function openStreamingService(service) {
    const searchQuery = encodeURIComponent(`${todaysSong.title_short} ${todaysSong.artist.name}`);
    let url;

    switch (service) {
      case 'deezer':
        url = todaysSong.link || `https://www.deezer.com/search/${searchQuery}`;
        break;
      case 'spotify':
        url = `https://open.spotify.com/search/${searchQuery}`;
        break;
      case 'apple':
        url = `https://music.apple.com/search?term=${searchQuery}`;
        break;
      case 'youtube':
        url = `https://music.youtube.com/search?q=${searchQuery}`;
        break;
      default:
        return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
    setShowStreamingDropdown(false);
  }

  function handleStatsPage() {
    window.open('/stats', '_blank', 'noopener,noreferrer');
  }

  return (
    <div className="result-container">
      <div className="result-screen">
        <div className="result-song">
          <img
            src={todaysSong.album.cover}
            alt="result album cover"
            width="150"
            height="150"
            className="result-album-cover"
          />
          <h2 className="result-song-title">{todaysSong.title_short}</h2>
          <p className="result-text">{todaysSong.artist.name}</p>
        </div>

        <h2 className="result-desc">{result_description}</h2>

        <div className="result-boxes">
          {result_box_class.map((cls, index) => (
            <span key={index} className={`result-box ${cls}`}></span>
          ))}
        </div>

        <p className="result-text result-comment">{result_comment}</p>

        <div className="result-actions">
          <button
            className="result-action-btn"
            onClick={handleShare}
            aria-label="Share your Jungle Jumble results"
          >
            Share
          </button>
          <div className="streaming-dropdown-container">
            <button
              className="result-action-btn listen-now-btn"
              onClick={handleListenNow}
              aria-label="Listen to this track on streaming platforms"
            >
              Listen
            </button>
            {showStreamingDropdown && (
              <div className="streaming-dropdown">
                <button
                  className="streaming-option"
                  onClick={() => openStreamingService('deezer')}
                >
                  Deezer
                </button>
                <button
                  className="streaming-option"
                  onClick={() => openStreamingService('spotify')}
                >
                  Spotify
                </button>
                <button
                  className="streaming-option"
                  onClick={() => openStreamingService('apple')}
                >
                  Apple Music
                </button>
                <button
                  className="streaming-option"
                  onClick={() => openStreamingService('youtube')}
                >
                  YouTube Music
                </button>
              </div>
            )}
          </div>
          <button
            className="result-action-btn stats-btn"
            onClick={handleStatsPage}
            aria-label="View game statistics"
          >
            Stats
          </button>
        </div>

        <p
          className="play-again-link"
          onClick={() => props.onResetGame()}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") props.onResetGame();
          }}
        >
          🔁 Play Again
        </p>

        <MidnightTimer />

        {showToast && (
          <div className="toast-notification">Copied results to clipboard! 📋</div>
        )}

        {showStreamingDropdown && (
          <div 
            className="dropdown-backdrop" 
            onClick={() => setShowStreamingDropdown(false)}
          />
        )}
      </div>
    </div>
  );
}